import { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import { generateInviteToken, generateInviteURL } from '../lib/invites';
import '../styles/QRCodeModal.css';

const QRCodeModal = ({ isOpen, onClose, groupId, eventId, issuedBy }) => {
  const [qrDataUrl, setQrDataUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inviteUrl, setInviteUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && issuedBy) {
      generateQRCode();
    } else {
      // Reset when modal closes
      setQrDataUrl(null);
      setInviteUrl(null);
      setError(null);
    }
  }, [isOpen, groupId, eventId, issuedBy]);

  const generateQRCode = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Generate invite token
      const target = groupId 
        ? { kind: 'group_join', id: groupId }
        : { kind: 'event_join', id: eventId };
      
      const token = await generateInviteToken(target, issuedBy, {
        oneTime: false, // QR codes should be reusable
        expiresIn: 30 * 24 * 60 * 60, // 30 days
      });

      // Generate invite URL
      const url = generateInviteURL(token);
      setInviteUrl(url);

      // Generate QR code
      const dataUrl = await QRCode.toDataURL(url, {
        width: 300,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      });
      
      setQrDataUrl(dataUrl);
    } catch (err) {
      console.error('Error generating QR code:', err);
      setError('Failed to generate QR code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = () => {
    if (inviteUrl) {
      navigator.clipboard.writeText(inviteUrl);
      alert('Invite link copied to clipboard!');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="qr-modal-header">
          <h2>Invite QR Code</h2>
          <button className="qr-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="qr-modal-body">
          {loading ? (
            <div className="qr-loading">Generating QR code...</div>
          ) : error ? (
            <div className="qr-error">{error}</div>
          ) : qrDataUrl ? (
            <>
              <div className="qr-code-container">
                <img src={qrDataUrl} alt="Invite QR Code" className="qr-code-image" />
              </div>
              {inviteUrl && (
                <div className="qr-link-section">
                  <p className="qr-link-label">Or share this link:</p>
                  <div className="qr-link-container">
                    <input
                      type="text"
                      value={inviteUrl}
                      readOnly
                      className="qr-link-input"
                    />
                    <button className="btn btn-primary btn-sm" onClick={handleCopyLink}>
                      Copy
                    </button>
                  </div>
                </div>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal;


